import { errorFallback, errorMessage, goBackMessage } from '@intl/generic';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import LogInButton from '@components/layout/LogInButton';

import Button from './Button';

const Error = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex justify-center items-center h-full">
      <div className="text-center">
        <h1 className="mb-2">
          <FormattedMessage {...errorMessage} />
        </h1>
        <p className="mb-6">
          <FormattedMessage {...errorFallback} />
        </p>

        <div className="flex gap-4 justify-center">
          <Button onClick={goBack} color="primary-bordered">
            <FormattedMessage {...goBackMessage} />
          </Button>

          <LogInButton />
        </div>
      </div>
    </div>
  );
};

export default Error;
